<template>
  <div>
    <div class="row" v-if="loading">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!loading">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="text-center text-primary my-2" v-if="loading">
                <b-spinner class="align-middle mr-2"></b-spinner>
                <strong>Loading...</strong>
              </div>
              <template v-if="!loading">
                <div class="d-flex bd-highlight">
                  <div class="me-auto p-2 bd-highlight" v-if="detailOp">
                    <h4 class="card-title">{{ detailOp.opportunity_name }}</h4>

                    <h6>
                      <span
                        v-for="(tag, tagI) in detailOp.tags"
                        :key="tagI"
                        class="badge me-2"
                        :style="'background-color:' + tag.color"
                      >
                        {{ tag.name }}
                      </span>
                    </h6>
                  </div>
                  <div class="p-2 bd-highlight">
                    <button
                      type="button"
                      @click="$router.go(-1)"
                      class="btn btn-light waves-effect waves-light"
                    >
                      Go Back
                    </button>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex bd-highlight mb-3">
                <div class="me-auto p-2 bd-highlight">
                  <h4 class="card-title">
                    <a class="text-muted">LEGAL ENTITY:</a>
                    {{ bidData.legal_entity.name.toUpperCase() }}
                  </h4>

                  <h4 class="card-title">
                    <a class="text-muted">UTILITY:</a>
                    {{ bidData.utility_state.name }}
                  </h4>

                  <p></p>
                  <h6 class="card-subtitle mb-2 text-muted">
                    {{ bidData.name }}
                  </h6>
                </div>

                <div class="p-2 bd-highlight">
                  <router-link
                    :to="
                      '/mpg/opportunities/' +
                      $route.params.id +
                      '/bid/' +
                      $route.params.bidId +
                      '/edit-from-bid'
                    "
                    class="btn btn-primary waves-effect waves-light"
                  >
                    Edit
                  </router-link>
                </div>

                <div class="p-2 bd-highlight">
                  <button
                    type="button"
                    class="btn btn-danger waves-effect waves-light"
                    data-bs-toggle="modal"
                    data-bs-target="#delete_bid_modal"
                    @click="
                      $bvModal.show('delete_bid_modal' + $route.params.bidId)
                    "
                  >
                    Delete
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <b-tabs
                    v-model="tabIndex"
                    class="nav-tabs-custom nav-justified"
                    active-tab-class="p-3"
                  >
                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="fas fa-details"></i
                        ></span>
                        <span class="d-none d-sm-block">Bid Details</span>
                      </template>
                      <b-card-title></b-card-title>
                      <b-card-text>
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="card h-100">
                              <div class="card-body">
                                <h4 class="card-title">Details</h4>

                                <p></p>

                                <div class="table-responsive">
                                  <table
                                    class="
                                      table
                                      align-middle
                                      table-striped table-nowrap
                                      mb-0
                                    "
                                  >
                                    <tbody>
                                      <tr>
                                        <td>Pricing Type</td>
                                        <td>
                                          <span
                                            class="badge bg-success me-2"
                                            v-for="(
                                              pricing, i
                                            ) in bidData.pricing_type"
                                            :key="i"
                                            >{{ pricing }}</span
                                          >
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Terms</td>
                                        <td>
                                          <span
                                            class="badge bg-warning"
                                            v-for="(terms, i) in bidData.terms"
                                            :key="i"
                                            >{{ terms }}</span
                                          >
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Swing</td>
                                        <td>
                                          <span
                                            class="badge bg-warning"
                                            v-for="(swing, i) in bidData.swing"
                                            :key="i"
                                            >{{ swing * 100 }}%</span
                                          >
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Site Count</td>

                                        <td>{{ bidData.site_count }}</td>
                                      </tr>

                                      <tr>
                                        <td>Meter Count</td>

                                        <td>{{ bidData.meter_count }}</td>
                                      </tr>

                                      <tr>
                                        <td>Start Date</td>

                                        <td>
                                          {{
                                            bidData.start_date
                                              ? moment(
                                                  bidData.start_date
                                                ).format("MMM DD, YYYY")
                                              : ""
                                          }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Annual Volume</td>

                                        <td>{{ bidData.annual_volume }}</td>
                                      </tr>
                                      <tr>
                                        <td>Pricing Point</td>

                                        <td>{{ bidData.pricing_point }}</td>
                                      </tr>
                                      <tr>
                                        <td>Index Name</td>

                                        <td>{{ bidData.index_name }}</td>
                                      </tr>
                                      <tr>
                                        <td>Special Pricing Needs ID</td>

                                        <td>
                                          {{ bidData.special_pricing_needs }}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td>New/Renewal</td>

                                        <td>{{ bidData.new_renewal }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6">
                            <div class="card h-100">
                              <div class="card-body">
                                <h4 class="card-title">Metadata</h4>

                                <p></p>

                                <div class="table-responsive">
                                  <table
                                    class="
                                      table
                                      align-middle
                                      table-striped table-nowrap
                                      mb-0
                                    "
                                  >
                                    <tbody>
                                      <tr>
                                        <td>Version</td>
                                        <td>{{ bidData.version }}</td>
                                      </tr>

                                      <tr>
                                        <td>Created by</td>
                                        <td>
                                          {{ bidData.created_by.username }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Created at</td>
                                        <td>
                                          {{
                                            moment(bidData.created_at).format(
                                              "MMM DD, YYYY HH:mm A"
                                            )
                                          }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Modified by</td>
                                        <td>
                                          {{ bidData.modified_by.username }}
                                        </td>
                                      </tr>

                                      <tr>
                                        <td>Modified at</td>
                                        <td>
                                          {{
                                            moment(bidData.modified_at).format(
                                              "MMM DD, YYYY HH:mm A"
                                            )
                                          }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <p></p>
                        <!-- <div class="row">
                          <div class="col-lg-12">
                            <div class="card h-100">
                              <div class="card-body">
                                <div class="float-end">
                                  <span class="text-muted">Unit:</span>
                                  <span
                                    class="fw-semibold"
                                    style="text-transform: uppercase"
                                    >{{ bidData.volume_unit }}</span
                                  >
                                </div>

                                <h4 class="card-title">Volumes</h4>

                                <p></p>

                                <div class="table-responsive">
                                  <table
                                    class="
                                      table
                                      align-middle
                                      table-striped table-nowrap
                                      mb-0
                                    "
                                  >
                                    <tbody>
                                      <tr>
                                        <td>January</td>
                                        <td>{{ bidData.january_volume }}</td>
                                        <td>July</td>
                                        <td>{{ bidData.july_volume }}</td>
                                      </tr>

                                      <tr>
                                        <td>February</td>
                                        <td>{{ bidData.february_volume }}</td>
                                        <td>August</td>
                                        <td>{{ bidData.august_volume }}</td>
                                      </tr>

                                      <tr>
                                        <td>March</td>
                                        <td>{{ bidData.march_volume }}</td>
                                        <td>September</td>
                                        <td>{{ bidData.september_volume }}</td>
                                      </tr>

                                      <tr>
                                        <td>April</td>
                                        <td>{{ bidData.april_volume }}</td>
                                        <td>October</td>
                                        <td>{{ bidData.october_volume }}</td>
                                      </tr>

                                      <tr>
                                        <td>May</td>
                                        <td>{{ bidData.may_volume }}</td>
                                        <td>November</td>
                                        <td>{{ bidData.november_volume }}</td>
                                      </tr>

                                      <tr>
                                        <td>June</td>
                                        <td>{{ bidData.june_volume }}</td>
                                        <td>December</td>
                                        <td>{{ bidData.december_volume }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div> -->

                        <p></p>
                      </b-card-text>
                    </b-tab>

                    <b-tab>
                      <template #title>
                        <span class="d-block d-sm-none"
                          ><i class="fas fa-details"></i
                        ></span>
                        <span class="d-none d-sm-block"
                          >Files
                          <span
                            class="badge rounded-pill bg-success float-end"
                            >{{ files.length }}</span
                          ></span
                        >
                      </template>
                      <b-card-title></b-card-title>
                      <b-card-text>
                        <div class="row">
                          <div class="col-lg-12">
                            <div class="drag-area">
                              <div>
                                <div
                                  :class="[
                                    'dropZone',
                                    dragging ? 'dropZone-over' : '',
                                  ]"
                                  @dragenter="dragging = true"
                                  @dragleave="dragging = false"
                                >
                                  <div class="dropZone-info" @drag="onChange">
                                    <span
                                      style="
                                        font-size: 21pt;
                                        margin-bottom: 15px;
                                        color: #bebebe;
                                      "
                                      class="
                                        fas
                                        fa-cloud-upload-alt
                                        dropZone-title
                                      "
                                    ></span>
                                    <span class="dropZone-title"
                                      >Drag and drop files here</span
                                    >
                                    <span> Or </span>
                                    <button
                                      type="button"
                                      class="
                                        btn btn-primary btn-sm btn-task
                                        mb-3
                                        mt-3
                                        removeFile
                                      "
                                      @click="fileInput.click()"
                                    >
                                      Browse files
                                    </button>
                                    <div class="dropZone-upload-limit-info">
                                      <div>extension support: *</div>
                                      <div>maximum file size: 5 MB</div>
                                    </div>
                                  </div>
                                  <input
                                    refs="fileInput"
                                    type="file"
                                    @change="onChange"
                                    multiple
                                  />
                                </div>
                              </div>
                            </div>

                            <template v-if="fileBeforeUpload">
                              <p></p>
                              <div
                                v-for="(fileData, index) in fileBeforeUpload"
                                :key="index"
                                class="file-list-item"
                              >
                                <a :href="fileData.file" target="_blank">
                                  {{ fileData.name }}
                                </a>
                                <button
                                  class="
                                    btn btn-link
                                    text-danger text-gradient
                                    px-3
                                    mb-0
                                  "
                                  :disabled="loadingAction"
                                  type="button"
                                  @click="deleteFileBeforeUpload(fileData)"
                                >
                                  <i
                                    class="far fa-trash-alt me-2"
                                    aria-hidden="true"
                                  ></i
                                  >Delete
                                </button>
                              </div>
                            </template>
                          </div>
                        </div>

                        <template v-if="files">
                          <div
                            v-for="(fileData, index) in files"
                            :key="index"
                            class="file-list-item"
                          >
                            <a :href="fileData.file" target="_blank">
                              {{ fileData.filename }}
                            </a>

                            <button
                              class="
                                btn btn-link
                                text-danger text-gradient
                                px-3
                                mb-0
                              "
                              :disabled="loadingAction"
                              type="button"
                              @click="deleteFile(fileData)"
                              ><i
                                class="far fa-trash-alt me-2"
                                aria-hidden="true"
                              ></i
                              >Delete</button
                            >
                          </div>
                        </template>

                        <p></p>
                        <div class="row">
                          <div class="col-12">
                            <button
                              :disabled="
                                !fileBeforeUpload ||
                                fileBeforeUpload.length === 0 ||
                                loadingAction
                              "
                              type="button"
                              class="btn btn-primary waves-effect waves-light"
                              @click="onUploadFileToOpp()"
                            >
                              Upload
                            </button>
                          </div>
                        </div>
                        <div v-if="files.length === 0" class="text-center">
                          There are no file(s)
                        </div>
                        <p></p>
                      </b-card-text>
                    </b-tab>
                  </b-tabs>
                </div>
                <b-modal
                  :id="'delete_bid_modal' + $route.params.bidId"
                  hide-footer
                >
                  <template #modal-header>
                    <h6 class="text-center">DELETE {{ bidData.name }}</h6>
                    <button
                      type="button"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      :disabled="loadingAction"
                      @click="
                        $bvModal.hide('delete_bid_modal' + $route.params.bidId)
                      "
                    ></button>
                  </template>

                  <div class="modal-body">
                    <h3 class="text-center">Are you sure?</h3>
                    <h6 class="text-center">
                      You won't be able to revert this.
                    </h6>
                    <div class="d-grid gap-2 d-md-block text-center">
                      <form method="POST">
                        <input
                          type="hidden"
                          name="csrfmiddlewaretoken"
                          value="5IvRf0lCfcVx5g8yX9FxZEK291PaKbC0E1KxuYxDTpkyJLzEnst6wagT8fXUeaPc"
                        />
                        <button
                          class="btn btn-danger waves-effect waves-light"
                          type="button"
                          name="delete_bid"
                          value="11"
                          @click="deleteBid($route.params.bidId)"
                        >
                          Delete
                        </button>
                        <button
                          class="btn btn-light waves-effect waves-light"
                          type="button"
                          data-bs-dismiss="modal"
                          @click="
                            $bvModal.hide(
                              'delete_bid_modal' + $route.params.bidId
                            )
                          "
                        >
                          Cancel
                        </button>
                      </form>
                    </div>
                  </div>
                </b-modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { opportunityService } from '../services/opportunities.service'
import { utilService } from '../services/util.service'
import { organizationsService } from '@/services/organizations.service'
import { bidsService } from '../services/bids.service'
import { authenticationService } from '../services/authentication.service'

import moment from 'moment'

export default {
  name: 'BidDetail',
  components: {},
  data () {
    return {
      detailOp: null,
      bidData: null,
      loading: true,
      loadingAction: false,
      tabIndex: 0,
      legalEntityList: [],
      utilityStateList: [],
      legal_entity: [],
      terms_tags: [],
      swing_tags: [],
      pricing_type_tags: [],
      utility_state: [],
      files: [],
      fileBeforeUpload: [],
      dragging: false
    }
  },
  computed: {},
  created () {
    if (!this.$route.params.id || this.$route.params.id === '') {
      this.$router.push('/mpg/opportunities')
    }
    if (!this.$route.params.bidId || this.$route.params.bidId === '') {
      this.$router.push('/mpg/opportunities')
    }

    this.termsList = utilService.getListTerm()
    this.pricingTypeList = utilService.getListPricingType()
    this.swingList = utilService.getListSwing()
    bidsService.getFileFile(this.$route.params.bidId).then((rs) => {
      this.files = rs.results
    })
    organizationsService
      .getData({
        q: '',
        ordering: '',
        limit: '9999999999',
        offset: 0,
        expands: ''
      })
      .then((rs) => {
        this.legalEntityList = rs.results.map((e) => {
          e.label = e.name
          e.code = e.organization_id
          return e
        })
        utilService.getUtilityState().then((utilityStates) => {
          this.utilityStateList = utilityStates.results
            .filter((c) => c.status === 'active')
            .map((e) => {
              e.label = e.name
              e.code = e.utility_state_id
              return e
            })
          opportunityService.getDataById(this.$route.params.id).then((opp) => {
            this.detailOp = opp
          })

          bidsService.getDataById(this.$route.params.bidId).then((bidData) => {
            this.bidData = bidData

            this.terms_tags = this.termsList.filter(
              (e) => bidData.terms.indexOf(parseInt(e.id)) > -1
            )
            this.swing_tags = this.swingList.filter(
              (e) => bidData.swing.indexOf(parseFloat(e.id)) > -1
            )
            this.pricing_type_tags = this.pricingTypeList.filter(
              (e) => bidData.pricing_type.indexOf(e.id) > -1
            )

            this.utility_state = this.utilityStateList.find(
              (e) => e.utility_state_id === bidData.utility_state
            )
            this.legal_entity = this.legalEntityList.find(
              (e) => e.organization_id === bidData.legal_entity
            )
            this.loading = false
          })
        })
      })
  },
  methods: {
    moment,
    deleteBid (id) {
      bidsService.deleteDataById(id).then((rs) => {
        this.$router.push(
          `/mpg/opportunities/${this.$route.params.id}/details`
        )
      })
    },
    deleteFile (file) {
      this.loadingAction = true
      bidsService
        .deleteFile(file.file_id)
        .then((rs) => {
          this.loadingAction = false
          this.$bvToast.toast('Delete successfully.', {
            title: `Update`,
            variant: 'primary',
            solid: true
          })
          this.files = this.files.filter((e) => e.file_id !== file.file_id)
        })
        .catch(() => {
          this.loadingAction = false
          this.$bvToast.toast('Cannot delete this file.', {
            title: `Error`,
            variant: 'danger',
            solid: true
          })
        })
    },
    onChange (e) {
      var files = e.target.files || e.dataTransfer.files

      if (!files.length) {
        this.dragging = false
        return
      }

      this.createFile(files)
    },
    createFile (files) {
      // if (!file.type.match('text.*')) {
      //   alert('please select txt file');
      //   this.dragging = false;
      //   return;
      // }

      const inValidFile = []

      for (let i = 0; i < files.length; i++) {
        if (files[i].size > 5000000) {
          inValidFile.push(files[i])
        }
      }

      if (inValidFile.length > 0) {
        this.$bvToast.toast('Error.', {
          title: `Please check file size no over 5 MB.`,
          variant: 'danger',
          solid: true
        })
        this.dragging = false
        return
      }

      this.fileBeforeUpload = [...this.fileBeforeUpload, ...files]
      this.dragging = false
    },

    deleteFileBeforeUpload (fileData) {
      this.fileBeforeUpload = this.fileBeforeUpload.filter(
        (e) => e.name !== fileData.name
      )
    },

    onUploadFileToOpp () {
      if (this.fileBeforeUpload.length > 0) {
        const type = authenticationService.currentContentTypeValue
        const contentType = type.find((e) => e.model === 'file').id
        this.loadingAction = true
        const promise = []
        for (let i = 0; i < this.fileBeforeUpload.length; i++) {
          let formData = new FormData()
          formData.append('file', this.fileBeforeUpload[i])
          formData.append('filename', this.fileBeforeUpload[i].name)
          formData.append('object_id', this.$route.params.bidId)
          formData.append('content_type', contentType)
          promise.push(
            bidsService.uploadFile(formData).then(
              (rs) => {
                return rs
              },
              (error) => {
                this.$bvToast.toast('Error.', {
                  title: `Error. Cannot Upload File ${error}`,
                  variant: 'danger',
                  solid: true
                })
              }
            )
          )
        }
        Promise.all(promise).then((values) => {
          this.$nextTick(() => {
            setTimeout(() => {
              bidsService
                .getFileFile(this.$route.params.bidId)
                .then((files) => {
                  this.files = files.results
                  this.loadingAction = false
                  this.fileBeforeUpload = []
                })
            }, 100)
          })
        })
      } else {
        this.loadingAction = false
      }
    }
  }
}
</script>

<style scoped>
.file-list-item {
  margin-bottom: 7px;
  background: #eee;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 6px;
}
.removeFile {
  width: 200px;
}

.dropZone {
  width: 100%;
  height: 300px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px dashed #0060ae;
}

.dropZone:hover .dropZone-title {
  color: #0060ae;
}

.dropZone-info {
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  -webkit-transform: translate(0, -50%);
  transform: translate(0, -50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #008dff1f;
  opacity: 0.8;
}

.dropZone-uploaded {
  width: 100%;
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #a8a8a8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.picker-input {
  position: relative;
  z-index: 98;
  width: 50px;
}
.picker-box {
  position: absolute;
  top: 47px;
  left: 1px;
  z-index: 99;
}
.picker-fade {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 97;
  left: 0;
  top: 0;
}

.form-control-color {
  padding: 0.47rem !important;
  height: 39px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/BidDetail.vue